import type { ReactNode } from 'react';
import { Icon } from '../ui/Icon';
import type { StatusMeta } from './status';

/** One status dimension: always text and an icon with its tone (docs/product-ux 08). */
export function StatusBadge({
  meta,
  children,
}: {
  readonly meta: StatusMeta;
  readonly children?: ReactNode;
}) {
  return (
    <span className={`status-badge status-badge--${meta.tone}`}>
      <Icon name={meta.icon} />
      {children ?? meta.label}
    </span>
  );
}
